export default "__VITE_ASSET__9bf52375__"